export default {
  referralCodes: [],
  utmTagBonuses: []
}
